import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Toast, PasswordResetMessage } from '@repo/common';

import { resendPasswordResetEmail } from '../../api/user/user.api';

const ForgotPasswordVerify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const [showToast, setShowToast] = useState(false);
  const [toastExiting, setToastExiting] = useState(false);
  const [toastKey, setToastKey] = useState(0);

  const triggerToast = () => {
    setToastKey((prev) => prev + 1);
    setShowToast(true);

    setTimeout(() => {
      setToastExiting(true);

      setTimeout(() => {
        setToastExiting(false);
      }, 300);
    }, 2000);
  };

  const handleResendEmail = useCallback(async () => {
    try {
      await resendPasswordResetEmail(email);
      triggerToast();
    } catch (error) {
      throw error;
    }
  }, [email]);

  const handleGoBack = () => {
    navigate('/password');
  };

  return (
    <div className='flex items-center justify-center min-h-screen bg-grayscale-gray01'>
      <div className='w-full max-w-[500px] tabletH:max-w-full'>
        <div className='flex items-center justify-center'>
          <PasswordResetMessage
            email={email}
            onResend={handleResendEmail}
            onGoBack={handleGoBack}
          />
        </div>
      </div>
      <div className='fixed left-1/2 -translate-x-1/2 tabletH:bottom-[23%] z-[1000]'>
        {showToast && (
          <>
            <div className='hidden tabletH:block'>
              <Toast
                visibleOn='desktop'
                key={toastKey}
                type='success'
                state='solid'
                title='A new reset link has been sent'
                hierarchy='important'
                direction='up'
                isExiting={toastExiting}
                fixedSize={true}
              />
            </div>
            <div className='block tabletH:hidden top-[calc(env(safe-area-inset-top)+60px)]'>
              <Toast
                visibleOn='mobile'
                key={toastKey}
                type='success'
                state='solid'
                title='A new reset link has been sent'
                hierarchy='small'
                direction='down'
                isExiting={toastExiting}
                customHeight='41px'
                customWidth='230px'
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordVerify;
